module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-radio-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00ee36d6!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/radio/src/radio-group.vue
// module id = 134
// module chunks = 2 3